import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UserInfoInterface } from '@core/models/authentication.model';
import { AuthenticationService } from '@core/services/authentication/authentication.service';
import { HasAccessDirective } from '@sharedModule/directives/has-access.directive';
import { MaterialModule } from '@sharedModule/material/material.module';
import { ChangePasswordPopupComponent } from '../change-password-popup/change-password-popup.component';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [CommonModule, MaterialModule, HasAccessDirective],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss',
})
export class ProfileComponent implements OnInit {
  userInfo!: UserInfoInterface;

  constructor(
    private dialogRef: MatDialog,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.userInfo = this.authenticationService.getUserInfo();
  }

  resetPasswordDialog(): void {
    this.dialogRef.open(ChangePasswordPopupComponent, {
      disableClose: true,
      data: this.userInfo,
    });
  }
}
